import React, { Outlet } from 'react-router-dom';

import { Stack } from '@mui/material';

import Layout from './Components/Layout';
import SubNavLink from './Components/SubNavLink';

const JobRequests = () => {
  return (
    <Layout message='Job Requests' isAvatarButtonsAvailable={false}>
      <Stack
        direction='row'
        gap={3}
        width='fit-content'
        mt={{ xs: 4, md: -2 }}
        mb={4}
        mx={{ xs: 'auto', md: 'unset' }}
      >
        <SubNavLink to='response'>Waiting for your Response</SubNavLink>
        {/* <SubNavLink to='advance'>Waiting for Advance</SubNavLink> */}
      </Stack>
      <Outlet />
    </Layout>
  );
};

export default JobRequests;
